<div mat-dialog-content class="dialog-content text-center">
  <div class="icon-wrapper">
    <mat-icon class="delete-icon">verified</mat-icon>
  </div>

  <h2 class="dialog-title pt-3 font-name">Enable this link?</h2>
  <p class="dialog-message pt-1 font-name">
   The link will become accessible again to candidates within its validity window.
  </p>

  <div mat-dialog-actions align="center" class="dialog-actions">
    <button class="btn btn-color font-name" (click)="closeDialog()">
      Cancel
    </button>
    <button class="btn btn-danger ms-3 font-name" (click)="confirm()">
      Yes , Enable
    </button>
  </div>
</div>
